import { AliasBinding } from '../../rest/decorators/alias'
import { DynamicBinding, Serialisable } from '../../rest/utilities/serialisable'

export class Updatable extends Serialisable {
  protected mandatory: string[] = []
  protected updatable: string[] | null = null
  public ignored: string[] = []

  constructor(alias: unknown) {
    super(alias as AliasBinding)
  }

  setUpdatableFields(updatable: string[] | null = []) {
    this.updatable = updatable
  }

  setIgnoredFields(ignored: string[] = []) {
    this.ignored = ignored
  }

  private fieldToAlias(field: string) {
    let alias = field
    for (const attr in this.__alias) {
      if (this.__alias[attr]) {
        if (this.__alias[attr] === field) {
          alias = attr
          break
        }
      }
    }
    return alias
  }

  private aliasToField(alias: string) {
    let field = alias
    if (Object.prototype.hasOwnProperty.call(this.__alias, alias)) {
      field = (this.__alias as AliasBinding)[alias]
    }
    return field
  }

  override serialise(): object {
    const data = super.serialise() as DynamicBinding
    if (this.updatable === null) {
      if (this.ignored.length === 0) {
        return data
      }
      const filtered = {}
      Object.keys(data).forEach((alias) => {
        const field = this.aliasToField(alias)
        if (
          !this.ignored.includes(field) &&
          Object.prototype.hasOwnProperty.call(data, alias)
        ) {
          ;(filtered as DynamicBinding)[alias] = (data as DynamicBinding)[alias]
        }
      })
      this.ignored = []
      return filtered
    } else {
      const updated = {}
      this.mandatory.concat(this.updatable).forEach((field) => {
        const alias = this.fieldToAlias(field)
        if (
          !this.ignored.includes(field) &&
          Object.prototype.hasOwnProperty.call(data, alias)
        ) {
          ;(updated as DynamicBinding)[alias] = (data as DynamicBinding)[alias]
        }
      })
      this.ignored = []
      return updated
    }
  }
}
